// extracted by mini-css-extract-plugin
export default {"section":"PreviewSection_section__bRe37","label":"PreviewSection_label__Yqfxo","value":"PreviewSection_value__SEKDE"};